var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"type":_vm.type,"dismissible":"","tile":""},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }